//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.DmCmMultiplePassesCiBuilder.js";
let d=[[[1,"ContactPositionBottomDistance",0,"CAM.InheritableToolDepBuilder",0],[1,"ContactPositionDistance",0,"CAM.InheritableToolDepBuilder",0],[0,"ContactPositionRingHeight",1,0],[1,"ContactPositionTopDistance",0,"CAM.InheritableToolDepBuilder",0],[0,"DmCmEndCutDisType",1,1],[0,"DmCmEndCutExtend",1,1],[0,"DmCmEndCutRadio",1,0],[0,"DmCmEndCutToolAxisGuideDirection",1,"Direction",0],[0,"DmCmEndCutToolAxisGuideVector",1,0],[1,"DmCmFloorWallStockFloorBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"DmCmFloorWallStockSame",1,0],[1,"DmCmFloorWallStockWallBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"DmCmMultiplePassesBuilder",0,"CAM.DmCmMultiplePassesCiBuilder",0],[0,"DmCmStartCutDisType",1,1],[0,"DmCmStartCutExtend",1,1],[0,"DmCmStartCutRadio",1,0],[0,"DmCmStartCutToolAxisGuideDirection",1,"Direction",0],[0,"DmCmStartCutToolAxisGuideVector",1,0],[1,"EndExtDistSpecValueBuilder",0,"CAM.InheritableToolDepBuilder",0],[0,"FollowWallBottom",1,0],[1,"StartExtDistSpecValueBuilder",0,"CAM.InheritableToolDepBuilder",0],[1,"ToolPositionOffsetBuilder",0,"CAM.InheritableDoubleBuilder",0]],[],[]];
SPLM.CAM.DmCmBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.DmCmBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.DmCmBuilder.DmCmCutPointType = Object.freeze({
    "Custom" : "Custom", "Automatic" : "Automatic"});

SPLM.CAM.DmCmBuilder.ExtDisType = Object.freeze({
    "None" : "None", "Fixed" : "Fixed", "Percent" : "Percent"});

SPLM.CAM.DmCmBuilder.ToolAxisGuideVectorType = Object.freeze({
    "Auto" : "Auto", "Guide" : "Guide"});

SPLM.CAM.DmCmBuilder.ContactPositionRingHeightType = Object.freeze({
    "None" : "None", "Constant" : "Constant", "Variable" : "Variable"});

export default SPLM;